<div class="row topRow">
  <div class="col-sm-12">
    <add-healthinsurance [healthInsurance]="selectedHealthInsurance" (healthInsuranceAdded)="closeBottomSheet()"></add-healthinsurance>
  </div>
</div>